import { Component, Input } from '@angular/core';

/**
 * Canonical "no data" placeholder for list screens (cards or tables).
 * Renders the shared `.empty` block — icon, heading, message — and projects an
 * optional call-to-action button. Screens with a create action pass an
 * `<app-button>` as content; screens without one (e.g. Members) leave it empty.
 *
 *   <app-empty-state
 *     icon="campaign"
 *     heading="promotions.emptyTitle"
 *     message="promotions.noPromotions"
 *   >
 *     <app-button [text]="'promotions.create' | transloco" routerLink="new"></app-button>
 *   </app-empty-state>
 *
 * `heading` and `message` are Transloco keys.
 */
@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  /** Material icon name shown above the heading. */
  @Input() icon = 'inbox';

  /** Transloco key for the bold heading line. */
  @Input() heading = '';

  /** Transloco key for the muted description line. */
  @Input() message = '';
}
